const currencies = {
  sourceCurrencies: [
    {
      targetCurrencies: [
        {
          currencyCode: "EUR",
          currencySymbol: "€",
          currencyName: "Euro",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AOA",
          currencySymbol: "Kz",
          currencyName: "Angolan Kwanza",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GBP",
          currencySymbol: "£",
          currencyName: "British Pound",
          minInvoiceAmount: 2.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "INR",
          currencySymbol: "₹",
          currencyName: "Indian Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CHF",
          currencySymbol: "Fr",
          currencyName: "Swiss Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AED",
          currencySymbol: "د.إ",
          currencyName: "UAE Dirham",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ARS",
          currencySymbol: "$",
          currencyName: "Argentine Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AUD",
          currencySymbol: "$",
          currencyName: "Australian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AWG",
          currencySymbol: "Afl.",
          currencyName: "Aruban Florin",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BBD",
          currencySymbol: "$",
          currencyName: "Barbados Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BGN",
          currencySymbol: "лв",
          currencyName: "Bulgarian Lev",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BIF",
          currencySymbol: "FBu",
          currencyName: "Burundian Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BRL",
          currencySymbol: "R$",
          currencyName: "Brazilian Real",
          minInvoiceAmount: 10.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BWP",
          currencySymbol: "P",
          currencyName: "Botswana Pula",
          minInvoiceAmount: 7.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BMD",
          currencySymbol: "$",
          currencyName: "Bermudian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BND",
          currencySymbol: "$",
          currencyName: "Brunei Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CAD",
          currencySymbol: "$",
          currencyName: "Canadian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CLP",
          currencySymbol: "$",
          currencyName: "Chilean Peso",
          minInvoiceAmount: 2.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CNY",
          currencySymbol: "¥",
          currencyName: "Chinese Yuan",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "COP",
          currencySymbol: "$",
          currencyName: "Colombian Peso",
          minInvoiceAmount: 13.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CRC",
          currencySymbol: "₡",
          currencyName: "Costa Rican Colón",
          minInvoiceAmount: 2.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CDF",
          currencySymbol: "FC",
          currencyName: "Congolese Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CZK",
          currencySymbol: "Kč",
          currencyName: "Czech Koruna",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "DKK",
          currencySymbol: "kr",
          currencyName: "Danish Krone",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "DJF",
          currencySymbol: "Fdj",
          currencyName: "Djiboutian Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "EGP",
          currencySymbol: "£",
          currencyName: "Egyptian Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "FJD",
          currencySymbol: "$",
          currencyName: "Fijian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "FKP",
          currencySymbol: "£",
          currencyName: "Falkland Islands Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GEL",
          currencySymbol: "₾",
          currencyName: "Georgian Lari",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GHS",
          currencySymbol: "₵",
          currencyName: "Ghanaian Cedi",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GIP",
          currencySymbol: "£",
          currencyName: "Gibraltar Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GMD",
          currencySymbol: "D",
          currencyName: "Gambian Dalasi",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GNF",
          currencySymbol: "FG",
          currencyName: "Guinean Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "HKD",
          currencySymbol: "$",
          currencyName: "Hong Kong Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "HNL",
          currencySymbol: "L",
          currencyName: "Honduran Lempira",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "HUF",
          currencySymbol: "Ft",
          currencyName: "Hungarian Forint",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "HTG",
          currencySymbol: "G",
          currencyName: "Haitian Gourde",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "IDR",
          currencySymbol: "Rp",
          currencyName: "Indonesian Rupiah",
          minInvoiceAmount: 4.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ILS",
          currencySymbol: "₪",
          currencyName: "Israeli Shekel",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "IRR",
          currencySymbol: "﷼",
          currencyName: "Iranian Rial",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "JPY",
          currencySymbol: "¥",
          currencyName: "Japanese Yen",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KES",
          currencySymbol: "KSh",
          currencyName: "Kenyan Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KRW",
          currencySymbol: "₩",
          currencyName: "South Korean Won",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KPW",
          currencySymbol: "₩",
          currencyName: "North Korean Won",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LKR",
          currencySymbol: "Rs",
          currencyName: "Sri Lankan Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MAD",
          currencySymbol: "د.م.",
          currencyName: "Moroccan Dirham",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KMF",
          currencySymbol: "CF",
          currencyName: "Comorian Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MXN",
          currencySymbol: "$",
          currencyName: "Mexican Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MYR",
          currencySymbol: "RM",
          currencyName: "Malaysian Ringgit",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NGN",
          currencySymbol: "₦",
          currencyName: "Nigerian Naira",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NOK",
          currencySymbol: "kr",
          currencyName: "Norwegian Krone",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NPR",
          currencySymbol: "Rs",
          currencyName: "Nepalese Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NZD",
          currencySymbol: "$",
          currencyName: "New Zealand Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KYD",
          currencySymbol: "$",
          currencyName: "Cayman Islands Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PHP",
          currencySymbol: "₱",
          currencyName: "Philippine Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PLN",
          currencySymbol: "zł",
          currencyName: "Polish Złoty",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "RON",
          currencySymbol: "lei",
          currencyName: "Romanian Leu",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "RUB",
          currencySymbol: "₽",
          currencyName: "Russian Ruble",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "RWF",
          currencySymbol: "FRw",
          currencyName: "Rwandan Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SEK",
          currencySymbol: "kr",
          currencyName: "Swedish Krona",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SGD",
          currencySymbol: "$",
          currencyName: "Singapore Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SBD",
          currencySymbol: "$",
          currencyName: "Solomon Islands Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "THB",
          currencySymbol: "฿",
          currencyName: "Thai Baht",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TRY",
          currencySymbol: "₺",
          currencyName: "Turkish Lira",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TWD",
          currencySymbol: "NT$",
          currencyName: "New Taiwan Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PAB",
          currencySymbol: "B/.",
          currencyName: "Panamanian Balboa",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PGK",
          currencySymbol: "K",
          currencyName: "Papua New Guinean Kina",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UAH",
          currencySymbol: "₴",
          currencyName: "Ukrainian Hryvnia",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "VND",
          currencySymbol: "₫",
          currencyName: "Vietnamese Dong",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZAR",
          currencySymbol: "R",
          currencyName: "South African Rand",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "USD",
          currencySymbol: "$",
          currencyName: "US Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SAR",
          currencySymbol: "﷼",
          currencyName: "Saudi Riyal",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "QAR",
          currencySymbol: "﷼",
          currencyName: "Qatari Riyal",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KWD",
          currencySymbol: "د.ك",
          currencyName: "Kuwaiti Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BHD",
          currencySymbol: "ب.د",
          currencyName: "Bahraini Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "OMR",
          currencySymbol: "ر.ع.",
          currencyName: "Omani Rial",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PKR",
          currencySymbol: "₨",
          currencyName: "Pakistani Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BDT",
          currencySymbol: "৳",
          currencyName: "Bangladeshi Taka",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "JOD",
          currencySymbol: "د.ا",
          currencyName: "Jordanian Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KZT",
          currencySymbol: "₸",
          currencyName: "Kazakhstani Tenge",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UZS",
          currencySymbol: "so'm",
          currencyName: "Uzbekistani Soʻm",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AZN",
          currencySymbol: "₼",
          currencyName: "Azerbaijani Manat",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BYN",
          currencySymbol: "Br",
          currencyName: "Belarusian Ruble",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ISK",
          currencySymbol: "kr",
          currencyName: "Icelandic Króna",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "HRK",
          currencySymbol: "kn",
          currencyName: "Croatian Kuna",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "RSD",
          currencySymbol: "дин.",
          currencyName: "Serbian Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ETB",
          currencySymbol: "Br",
          currencyName: "Ethiopian Birr",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TZS",
          currencySymbol: "TSh",
          currencyName: "Tanzanian Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UGX",
          currencySymbol: "USh",
          currencyName: "Ugandan Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZMW",
          currencySymbol: "K",
          currencyName: "Zambian Kwacha",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NAD",
          currencySymbol: "N$",
          currencyName: "Namibian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TND",
          currencySymbol: "د.ت",
          currencyName: "Tunisian Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "DZD",
          currencySymbol: "د.ج",
          currencyName: "Algerian Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XOF",
          currencySymbol: "CFA",
          currencyName: "West African CFA Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XAF",
          currencySymbol: "CFA",
          currencyName: "Central African CFA Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GTQ",
          currencySymbol: "Q",
          currencyName: "Guatemalan Quetzal",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "DOP",
          currencySymbol: "RD$",
          currencyName: "Dominican Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BOB",
          currencySymbol: "Bs.",
          currencyName: "Bolivian Boliviano",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PEN",
          currencySymbol: "S/",
          currencyName: "Peruvian Sol",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PYG",
          currencySymbol: "Gs",
          currencyName: "Paraguayan Guaraní",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UYU",
          currencySymbol: "$U",
          currencyName: "Uruguayan Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ALL",
          currencySymbol: "L",
          currencyName: "Albanian Lek",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AMD",
          currencySymbol: "֏",
          currencyName: "Armenian Dram",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BAM",
          currencySymbol: "KM",
          currencyName: "Bosnia and Herzegovina Convertible Mark",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MDL",
          currencySymbol: "L",
          currencyName: "Moldovan Leu",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MKD",
          currencySymbol: "ден",
          currencyName: "North Macedonian Denar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LBP",
          currencySymbol: "ل.ل",
          currencyName: "Lebanese Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "IQD",
          currencySymbol: "ع.د",
          currencyName: "Iraqi Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "AFN",
          currencySymbol: "؋",
          currencyName: "Afghan Afghani",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KGS",
          currencySymbol: "с",
          currencyName: "Kyrgyzstani Som",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TJS",
          currencySymbol: "ЅМ",
          currencyName: "Tajikistani Somoni",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MMK",
          currencySymbol: "Ks",
          currencyName: "Myanmar Kyat",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LAK",
          currencySymbol: "₭",
          currencyName: "Lao Kip",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "KHR",
          currencySymbol: "៛",
          currencyName: "Cambodian Riel",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MNT",
          currencySymbol: "₮",
          currencyName: "Mongolian Tögrög",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MUR",
          currencySymbol: "₨",
          currencyName: "Mauritian Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SCR",
          currencySymbol: "₨",
          currencyName: "Seychellois Rupee",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MGA",
          currencySymbol: "Ar",
          currencyName: "Malagasy Ariary",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MOP",
          currencySymbol: "P$",
          currencyName: "Macanese Pataca",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MRU",
          currencySymbol: "UM",
          currencyName: "Mauritanian Ouguiya",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MVR",
          currencySymbol: "Rf",
          currencyName: "Maldivian Rufiyaa",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MWK",
          currencySymbol: "MK",
          currencyName: "Malawian Kwacha",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MZN",
          currencySymbol: "MT",
          currencyName: "Mozambican Metical",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "THB",
          currencySymbol: "฿",
          currencyName: "Thai Baht",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TRY",
          currencySymbol: "₺",
          currencyName: "Turkish Lira",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TTD",
          currencySymbol: "$",
          currencyName: "Trinidad and Tobago Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TWD",
          currencySymbol: "NT$",
          currencyName: "New Taiwan Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TZS",
          currencySymbol: "TSh",
          currencyName: "Tanzanian Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UAH",
          currencySymbol: "₴",
          currencyName: "Ukrainian Hryvnia",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "UGX",
          currencySymbol: "USh",
          currencyName: "Ugandan Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "USD",
          currencySymbol: "$",
          currencyName: "United States Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "VND",
          currencySymbol: "₫",
          currencyName: "Vietnamese Đồng",
          minInvoiceAmount: 23.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XAF",
          currencySymbol: "FCFA",
          currencyName: "Central African CFA Franc",
          minInvoiceAmount: 568.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XCD",
          currencySymbol: "$",
          currencyName: "East Caribbean Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZAR",
          currencySymbol: "R",
          currencyName: "South African Rand",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZMW",
          currencySymbol: "ZK",
          currencyName: "Zambian Kwacha",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "NIO",
          currencySymbol: "C$",
          currencyName: "Nicaraguan Córdoba",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CUP",
          currencySymbol: "$",
          currencyName: "Cuban Peso",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CVE",
          currencySymbol: "$",
          currencyName: "Cape Verdean Escudo",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ERN",
          currencySymbol: "Nfk",
          currencyName: "Eritrean Nakfa",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "JMD",
          currencySymbol: "$",
          currencyName: "Jamaican Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LRD",
          currencySymbol: "$",
          currencyName: "Liberian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LSL",
          currencySymbol: "L",
          currencyName: "Lesotho Loti",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "LYD",
          currencySymbol: "ل.د",
          currencyName: "Libyan Dinar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "MOP",
          currencySymbol: "P$",
          currencyName: "Macanese Pataca",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "PEN",
          currencySymbol: "S/",
          currencyName: "Peruvian Sol",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SDG",
          currencySymbol: "ج.س.",
          currencyName: "Sudanese Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SHP",
          currencySymbol: "£",
          currencyName: "Saint Helena Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SLE",
          currencySymbol: "Le",
          currencyName: "Sierra Leonean Leone",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SOS",
          currencySymbol: "Sh",
          currencyName: "Somali Shilling",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SRD",
          currencySymbol: "$",
          currencyName: "Surinamese Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "STN",
          currencySymbol: "Db",
          currencyName: "São Tomé and Príncipe Dobra",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SVC",
          currencySymbol: "₡",
          currencyName: "Salvadoran Colón",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SYP",
          currencySymbol: "£",
          currencyName: "Syrian Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SZL",
          currencySymbol: "E",
          currencyName: "Eswatini Lilangeni",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TMT",
          currencySymbol: "m",
          currencyName: "Turkmenistani Manat",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "TOP",
          currencySymbol: "T$",
          currencyName: "Tongan Paʻanga",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "VES",
          currencySymbol: "Bs.",
          currencyName: "Venezuelan Bolívar Soberano",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "VUV",
          currencySymbol: "VT",
          currencyName: "Vanuatu Vatu",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "WST",
          currencySymbol: "T",
          currencyName: "Samoan Tala",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XPF",
          currencySymbol: "₣",
          currencyName: "CFP Franc",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "YER",
          currencySymbol: "﷼",
          currencyName: "Yemeni Rial",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZWL",
          currencySymbol: "Z$",
          currencyName: "Zimbabwean Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ANG",
          currencySymbol: "ƒ",
          currencyName: "Netherlands Antillean Guilder",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BSD",
          currencySymbol: "$",
          currencyName: "Bahamian Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BTN",
          currencySymbol: "Nu.",
          currencyName: "Bhutanese Ngultrum",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BZD",
          currencySymbol: "$",
          currencyName: "Belize Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GYD",
          currencySymbol: "$",
          currencyName: "Guyanese Dollar",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SSP",
          currencySymbol: "£",
          currencyName: "South Sudanese Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "SLL",
          currencySymbol: "Le",
          currencyName: "Sierra Leonean Leone (legacy)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "GGP",
          currencySymbol: "£",
          currencyName: "Guernsey Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "JEP",
          currencySymbol: "£",
          currencyName: "Jersey Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "IMP",
          currencySymbol: "£",
          currencyName: "Isle of Man Pound",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "BTC",
          currencySymbol: "₿",
          currencyName: "Bitcoin (non-ISO)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CLF",
          currencySymbol: "UF",
          currencyName: "Unidad de Fomento (Chile)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CNH",
          currencySymbol: "¥",
          currencyName: "Chinese Yuan (Offshore)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "CUC",
          currencySymbol: "$",
          currencyName: "Cuban Convertible Peso (retired)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "STD",
          currencySymbol: "Db",
          currencyName: "São Tomé and Príncipe Dobra (legacy)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XAG",
          currencySymbol: "Ag",
          currencyName: "Silver (troy ounce)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XAU",
          currencySymbol: "Au",
          currencyName: "Gold (troy ounce)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XDR",
          currencySymbol: "SDR",
          currencyName: "IMF Special Drawing Rights",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XPD",
          currencySymbol: "Pd",
          currencyName: "Palladium (troy ounce)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XPT",
          currencySymbol: "Pt",
          currencyName: "Platinum (troy ounce)",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "ZWG",
          currencySymbol: "ZiG",
          currencyName: "Zimbabwean ZiG",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
        {
          currencyCode: "XCG",
          currencySymbol: "Cg",
          currencyName: "Caribbean Guilder",
          minInvoiceAmount: 1.0,
          fixedTargetPaymentAllowed: true,
        },
      ],
      totalTargetCurrencies: 172,
    },
  ],
  total: 1,
};

// Ensure target currencies are alphabetically ordered by currencyCode
if (
  currencies &&
  Array.isArray(currencies.sourceCurrencies) &&
  currencies.sourceCurrencies[0] &&
  Array.isArray(currencies.sourceCurrencies[0].targetCurrencies)
) {
  currencies.sourceCurrencies[0].targetCurrencies.sort((a, b) =>
    (a?.currencyCode || '').localeCompare(b?.currencyCode || '')
  );
  // Deduplicate by currencyCode after sorting
  const seenCodes = new Set();
  currencies.sourceCurrencies[0].targetCurrencies = currencies.sourceCurrencies[0].targetCurrencies.filter((item) => {
    const code = item && item.currencyCode;
    if (!code) return false;
    if (seenCodes.has(code)) return false;
    seenCodes.add(code);
    return true;
  });
  if (typeof currencies.sourceCurrencies[0].totalTargetCurrencies !== 'undefined') {
    currencies.sourceCurrencies[0].totalTargetCurrencies = currencies.sourceCurrencies[0].targetCurrencies.length;
  }
}

export default currencies;
